import { Button, cn } from 'shared-components';
import { type FunctionComponent } from 'react';

import { type FontSettingsProps, type FontSize } from './FontSettings.types';

const OPTIONS: { size: FontSize; label: string }[] = [
  { size: 'normal', label: 'A' },
  { size: 'large', label: 'A+' },
  { size: 'x-large', label: 'A++' },
];

const FontSettings: FunctionComponent<FontSettingsProps> = ({ value, onValueChange, dataTestid, className }) => (
  <ul className={cn('m-0 flex list-none items-end gap-1 p-0 sm:gap-4', className)} data-testid={dataTestid}>
    {OPTIONS.map((option) => (
      <li key={option.size}>
        <Button
          name={`font-size-${option.size}`}
          variant="ghost"
          aria-pressed={value === option.size}
          onClick={() => onValueChange(option.size)}
          className={cn('box-border font-medium! text-secondary-900 [&_span]:items-end!', {
            'text-[16px] leading-6.5 sm:text-[16px] sm:leading-6': option.size === 'normal',
            'text-[18px] leading-6.75 sm:text-[22px]': option.size === 'large',
            'text-[22px] leading-7 sm:text-[28px]': option.size === 'x-large',
            'text-primary-600': Boolean(value === option.size),
          })}
        >
          {option.label}
        </Button>
      </li>
    ))}
  </ul>
);

FontSettings.displayName = 'FontSettings';
export { FontSettings };
